
export function cleanHtml(dirtyHtml) {
	return /(<body[\s\S]+<\/body>)/i.test(dirtyHtml) ? RegExp.$1 : dirtyHtml;
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/fileImportPlugin/modifier/cleanHtml.js